export default "__VITE_ASSET__BlUe4S8K__"